// 文件前缀
const iconurl = 'https://file-public.ilaas.cn/comdoc/v4/'
export {
    iconurl
}